import { computed } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { WHATS_NEW } from '@/graphql/whatsNew';
import type { WhatsNewEntriesQuery, WhatsNewEntriesQueryVariables } from '@/types/operations';

/**
 * The changelog entries this user can reach, newest first. The list only
 * changes on a deploy, so the cached copy is reused across the session.
 */
export function useWhatsNewEntries() {
  const { result, loading, error, refetch } = useQuery<WhatsNewEntriesQuery, WhatsNewEntriesQueryVariables>(
    WHATS_NEW,
    {},
    { fetchPolicy: 'cache-first' },
  );

  return {
    entries: computed(() => result.value?.whatsNew ?? []),
    loading,
    error,
    refetch,
  };
}
